import React from 'react';
export const READER_NUMBER_DATA = {
    READER_1:{
        id: 0,
        name: 'reader1_entry'
    },
    READER_2:{
        id: 1,
        name: 'reader2_entry'
    },
    READER_3:{
        id: 2,
        name: 'reader1_exit'
    },
    READER_4:{
        id: 3,
        name: 'reader2_exit'
    }
}

export const YES_NO_DATA = {
    YES:{
        id: 'true',
        name: 'YES'
    },
    NO:{
        id: 'false',
        name: 'NO'
    },
}

/**
 * Retrieves the corresponding YES/NO label based on the provided identifier.
 *
 * <p>If no matching value is found, the default value returned is NO.</p>
 *
 * @param {string|boolean} id the identifier to evaluate
 * @returns {string} the corresponding YES/NO label
 */
export const getYesNoNameById = (id) => {
    return Object.values(YES_NO_DATA)
        .find(item => item.id === String(id))
        ?.name || YES_NO_DATA.NO.name;
};

export const PROTOCOL_DATA = {
    WIEGAND:{
        id: 'WIEGAND',
        name: 'WIEGAND'
    },
    OSDP_V1:{
        id: 'OSDP_V1',
        name: 'OSDP V1'
    },
    OSDP_V2:{
        id: 'OSDP_V2',
        name: 'OSDP V2'
    }
}

// Baud rates the reader can communicate at, sent as int
export const BAUD_RATE_DATA = [9600, 19200, 38400, 57600, 115200, 230400];

export const READER_MODE_DATA = {
    MODE_1:{
        id: 1,
        name: 'DISABLE'
    },
    MODE_2:{
        id: 2,
        name: 'UNLOCK'
    },
    MODE_3:{
        id: 3,
        name: 'LOCKED'
    },
    MODE_4:{
        id: 4,
        name: 'FACILITY_CODE'
    },
    MODE_5:{
        id: 5,
        name: 'CARD_ONLY'
    },
    MODE_6:{
        id: 6,
        name: 'PIN_ONLY'
    },
    MODE_7:{
        id: 7,
        name: 'CARD_AND_PIN'
    },
    MODE_8:{
        id: 8,
        name: 'CARD_OR_PIN'
    },
    MODE_9:{
        id: 9,
        name: 'LINKING'
    }
}

export const READER_DATA = {
    id: null,
    hidSioId: null,
    name: '',
    readerMode: null,
    deviceAccessTypeId: null,
    hasKeyPad: null,
    communicationProtocol: null,
    baudRate: null,
    secureChannelEnabled: false,
    number: null,
    readerNo: null,
    controllerId: null,
    isValid : function () {
        return this.hidSioId!= null &&
            this.name != null && this.name != '' &&
            this.readerMode != null &&
            this.deviceAccessTypeId != null &&
            this.hasKeyPad != null &&
            this.communicationProtocol != null &&
            this.baudRate != null &&
            this.controllerId != null ;
    },
    toAddEdit : function () {
        return {
            hidSioId: this.hidSioId,
            name: this.name,
            deviceAccessTypeId: this.deviceAccessTypeId,
            accessType: this.deviceAccessTypeId,
            readerMode: this.readerMode,
            readerNo: this.readerNo,
            hasKeyPad: this.hasKeyPad,
            communicationProtocol: this.communicationProtocol,
            baudRate: parseInt(this.baudRate),
            secureChannelEnabled: this.secureChannelEnabled
        }
    },
    set : function (data, sioName) {
        return {
            id: data.id,
            hidSioId: data.hidSioId,
            hidSioName: sioName,
            name: data.name,
            deviceAccessTypeId: data.deviceAccessTypeId,
            accessType: data.deviceAccessTypeId,
            readerMode: data.readerMode,
            readerNo: data.readerNo,
            hasKeyPad: data.hasKeyPad,
            communicationProtocol: data.communicationProtocol,
            baudRate: data.baudRate,
            secureChannelEnabled: data.secureChannelEnabled
        }
    }
}

